
const GuacamoleControls = ({ totalTime, consumedHours, isExpired, vmStarted, processing, vmStatus, remainingSeconds, totalAllocatedSeconds, bootProgress, timeRemaining, currentStep, restartStep, startVM, stopVM, resetVM, loadVMList, formatTime
}) => {

    const radius = 35;
    const circumference = 2 * Math.PI * radius;

    const progress =
        totalAllocatedSeconds > 0
            ? (remainingSeconds / totalAllocatedSeconds) * 100
            : 0;

   const strokeDashoffset = isExpired
    ? 0
    : circumference * (1 - progress / 100);

 const circleColor = isExpired
    ? "#f44336"
    : progress < 10
        ? "#f44336"
        : progress < 30
            ? "#ff9800"
            : "#4CAF50";

    return (
      <>
        <div className="row g-5 align-items-stretch p-3">
            <div className="col-12 col-sm-6 col-md-6 col-lg-3 d-flex">
                <div className="analytics-container">
                    <div className="header">
                        <div className="icon"></div>
                        <h1 className="title">Usage Analytics</h1>
                    </div>
                    <p className="subtitle">Track your lab session time</p>
                    <div className="timer-container">
                        <div className="timer-circle">
                            <svg viewBox="0 0 80 80" style={{ transform: "rotate(-90deg)" }}>
                                <circle
                                    cx="40"
                                    cy="40"
                                    r={radius}
                                    stroke="#e9ecef"
                                    fill="none"
                                    strokeWidth="4"
                                />
                                {(progress > 0 || isExpired) && (
                                    <circle
                                        cx="40"
                                        cy="40"
                                        r={radius}
                                        fill="none"
                                        stroke={circleColor}
                                        strokeWidth="3"
                                        strokeDasharray={circumference}
                                        strokeDashoffset={strokeDashoffset}
                                        style={{
                                            transition: "stroke-dashoffset 1s linear"
                                        }}
                                    />
                                )}
                            </svg>
<div className="progress-center">
  {isExpired ? (
    <div className="fs-5" style={{ color: "#f44336", fontWeight: "600" }}>
      Expired
    </div>
  ) : (
    <>
     <div className="timer-label">
  {consumedHours && consumedHours !== "0h" ? "Remaining" : "Total"}
</div>
      <div className="timer-value">{totalTime}</div>
    </>
  )}
</div>
                        </div>
                    </div>
                </div>
            </div>
   {vmStatus !== 'running' && (
                <div className="col-12 col-sm-6 col-md-6 col-lg-3 d-flex text-center">
                    <div className={`vm-container shadow ${vmStarted || processing || isExpired ? 'disabled' : ''}`}>

                        {vmStatus === 'starting' ? (
                            <div className="mb-3">
                                {/* Progress Circle */}
                                <div className="d-flex justify-content-center mb-3">
                                    <div className="progress-circle">
                                        <svg viewBox="0 0 80 80">
                                            <circle
                                                cx="40"
                                                cy="40"
                                                r="35"
                                                fill="none"
                                                stroke="#e9ecef"
                                                strokeWidth="4"
                                            />
                                            <circle
                                                cx="40"
                                                cy="40"
                                                r="35"
                                                fill="none"
                                                stroke="#4CAF50"
                                                strokeWidth="4"
                                                strokeLinecap="round"
                                                strokeDasharray={`${2 * Math.PI * 35}`}
                                                strokeDashoffset={`${2 * Math.PI * 35 * (1 - bootProgress / 100)}`}
                                                style={{ transition: 'stroke-dashoffset 0.3s ease-out' }}
                                            />
                                        </svg>
                                        <div className="progress-center">
                                            <div className="small fw-bold text-dark">
                                                {/* {Math.round(bootProgress)}% */}
                                                <div className="play-icon"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Current Step */}
                                <div className="text-center">
                                    <div className="small text-muted fw-bold">
                                        ETA: {formatTime(timeRemaining)}
                                    </div>
                                </div>
                            </div>
                        ) : (<div className="play-icon"></div>)}
                        <h3 className="title">{vmStatus === 'starting' ? 'Starting' : (vmStatus === 'running' ? 'Running' : 'Start Your Bay')}</h3>
                        <button
                            className="start-button mt-4"
                            disabled={vmStatus !== 'stopped'|| isExpired || remainingSeconds <= 0}
                            onClick={startVM}
                        >
                            {vmStatus === 'starting' ? 'Processing' : 'Start Bay'}
                        </button>

                    </div>
                </div>
            )}
   {vmStatus === 'running' && (

                <div className="col-12 col-sm-6 col-md-6 col-lg-3 d-flex text-center">
                    <div className={`vm-container shadow ${vmStarted === false || processing ? 'disabled' : ''}`}>
                        <div className="stop-icon"></div>
                        <h3 className="title">Stop Your Bay</h3>
                        <button
                            className="stop-button mt-4"
                            onClick={stopVM}
                        >
                            Stop Bay
                        </button>
                    </div>
                </div>
            )}
              <div className="col-12 col-sm-6 col-md-6 col-lg-3 d-flex text-center">
                <div className={`vm-container shadow ${vmStarted === false || processing ? 'disabled' : ''}`}>
                    <div className="split-icon">
                        <div className="monitor"></div></div>
                    <h3 className="title">{vmStarted ? 'Go to Your Bay' : 'Go to Your Bay'}</h3>
                    <button className='split-button mt-4'
                        disabled={vmStatus !== 'running'|| isExpired || remainingSeconds <= 0}
                        onClick={loadVMList}>
                        {vmStarted ? 'Go to Bay' : 'Go to Bay'}
                    </button>
                </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3 d-flex text-center">
                <div className={`vm-container shadow ${vmStarted === false || processing ? 'disabled' : ''}`}>
                    {vmStatus === 'restarting' ? (
                        <div className="mb-3">
                            {/* Progress Circle */}
                            <div className="d-flex justify-content-center mb-3">
                                <div className="progress-circle">
                                    <svg viewBox="0 0 80 80">
                                        <circle
                                            cx="40"
                                            cy="40"
                                            r="35"
                                            fill="none"
                                            stroke="#e9ecef"
                                            strokeWidth="4"
                                        />
                                        <circle
                                            cx="40"
                                            cy="40"
                                            r="35"
                                            fill="none"
                                            stroke="#26C6DA"
                                            strokeWidth="4"
                                            strokeLinecap="round"
                                            strokeDasharray={`${2 * Math.PI * 35}`}
                                            strokeDashoffset={`${2 * Math.PI * 35 * (1 - bootProgress / 100)}`}
                                            style={{ transition: 'stroke-dashoffset 0.3s ease-out' }}
                                        />
                                    </svg>
                                    <div className="progress-center">
                                        <div className="small fw-bold text-dark">
                                            <div className="reset-icon"></div>
                                            {/* {Math.round(bootProgress)}% */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Current Step */}
                            <div className="text-center">
                                <div className="small text-muted">
                                    ETA: {formatTime(timeRemaining)}
                                </div>
                            </div>
                        </div>
                    ) : (<div className="reset-icon"></div>)}
                    <h3 className="title">{vmStatus === 'restarting' ? 'Restarting' : 'Restart Your Bay'}</h3>
                    <button className='reset-button mt-4'
                        disabled={vmStatus !== 'running' || isExpired || remainingSeconds <= 0}
                        onClick={resetVM}>
                        {vmStatus === 'restarting' ? 'Processing' : 'Restart Bay'}</button>
                </div>
            </div>
      
        </div>
<div className="row mt-5 pt-5">
  <div className="col-12 d-flex justify-content-center">
    <div
      style={{
        padding: "12px 20px",
        borderRadius: "10px",
        fontSize: "1rem",
        maxWidth: "780px",
        textAlign: "center", 
      }}
    >
      <span className="fs-4 me-1">
  ⚠️
</span><strong>Important Notice :</strong> Your Bay session will remain active until you click 
      <strong> “Stop Bay” </strong>. <p>To avoid unnecessary usage, please stop your Bay after completing your hands-on session.
        </p>
    </div>
  </div>
</div>
        </>
    );
};

export default GuacamoleControls;